import { useState } from "react";
import { Link } from "react-router-dom";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/ebook", label: "The Book" },
  { to: "/cage-system", label: "Cage System" },
  { to: "/the-mission", label: "The Mission" },
  { to: "/about", label: "My Story" },
  { to: "/contact", label: "Contact" },
];
const LEGAL = [
  { to: "/privacy", label: "Privacy Policy", newTab: true },
  { to: "/risk-disclosure", label: "Risk Disclosure", newTab: true },
  { to: "/terms", label: "Terms" },
];

export default function Footer() {
  const [copied, setCopied] = useState(false);
  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard may be unavailable */
    }
  };
  return (
    <footer className="border-t border-hairline mt-28" data-testid="site-footer">
      <div className="max-w-screen-xl mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Link to="/" className="inline-flex items-center gap-1" aria-label="Return to Biology Trader homepage" data-testid="footer-brand-link">
            <span className="font-display text-3xl leading-none text-ink" style={{ fontWeight: 800 }}>The Biology Trader</span>
            <span className="text-sm align-top text-[#245943] ml-0.5 mt-[-6px]" aria-hidden="true">™</span>
          </Link>
          <p className="mt-6 max-w-sm text-muted leading-relaxed text-[15px]">
            Trading within biological limits. Writing on why discipline fails under pressure, and what actually works.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="label-mono text-ink mb-5">Pages</div>
          <ul className="space-y-3">
            {NAV.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="nav-link text-ink/90 hover:text-ink text-[15px]" data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="label-mono text-ink mb-5">Legal</div>
          <ul className="space-y-3">
            {LEGAL.map((l) => (
              <li key={l.to}>
                <Link to={l.to} {...(l.newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})} className="nav-link text-ink/90 hover:text-ink text-[15px]" data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</Link>
              </li>
            ))}
          </ul>
          <p
            className="block mt-6 text-xs text-muted leading-relaxed max-w-xs"
            data-testid="footer-risk-line"
          >
            Trading involves substantial risk. Past performance does not guarantee future results.
          </p>
        </div>
      </div>
      <div className="border-t border-hairline">
        <div className="max-w-screen-xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="label-mono text-muted" data-testid="footer-copyright">© {new Date().getFullYear()} Biology Trader Education LLC</p>
          <div className="flex items-center gap-5">
            <button
              type="button"
              onClick={handleShare}
              className="label-mono text-muted hover:text-ink transition-colors"
              data-testid="footer-share-link"
              aria-live="polite"
            >
              {copied ? "Link copied" : "Share"}
            </button>
            <p className="text-xs text-muted max-w-md">Educational content. Nothing here is financial advice.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
